import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isScannerShown: false,
    agreementAccepted: false,
  },
  mutations: {
    toggleScanning(state, payload) {
      state.isScannerShown = payload;
    },
    toggleAgreementAcceptance(state, payload) {
      state.agreementAccepted = payload;
    },
  },
});
